module.exports = __webpack_public_path__ + "img/expenses_square_top.19ac5c6f.svg";